import { render, staticRenderFns } from "./issue-status.vue?vue&type=template&id=553790ae"
import script from "./issue-status.vue?vue&type=script&lang=js"
export * from "./issue-status.vue?vue&type=script&lang=js"
import style0 from "./issue-status.vue?vue&type=style&index=0&id=553790ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports